import React from 'react';
import DataSelect from './DataSelect';
import ProfileTable from './ProfileTable';
import TubeTable from './TubeTable';
import ResetVor from './ResetVor';

import './Vorselektion.css';

function Vorselektion() {
  return (
    <React.Fragment>
      <div className='VorContainer'>
        <div className='DataSelect'>
          <DataSelect />
        </div>
        <div className='ResetVor'>
          <ResetVor />
        </div>
        <div className='ProfileTable'>
          <ProfileTable />
        </div>
        <div className='TubeTable'>
          <TubeTable />
        </div>
      </div>
    </React.Fragment>
  );
}

export default Vorselektion;
